export const createDoctorFields = [
    {
        name: "full_name",
        label: "Full Name",
        type: "text",
            placeholder: "Eg. Rakesh kumar",

        required: true,
           colSpan: {
            base: 6,
            sm: 6,
            md: 3,
            lg:1
        },
    },
    {
        name: "mobile",
        label: "Mobile Number",
        type: "mobile",
            placeholder: "Eg. 7788556688",

        required: true,
          colSpan: {
            base: 6,
            sm: 6,
            md: 3,
            lg:1
        },
    },
    {
        name: "email",
        label: "Email",
        type: "email",
            placeholder: "Eg. abc@gmail.com",

          colSpan: {
            base: 6,
            sm: 6,
            md: 3,
            lg:1
        },
    },

   {
        name: "qualification",
        label: "Qualification",
        type: "text",
            placeholder: "Eg. MBBS",

        required: true,
           colSpan: {
            base: 6,
            sm: 6,
            md: 3,
            lg:1
        },
    },
   {
        name: "specialization",
        label: "Specialization",
        type: "text",
            placeholder: "Eg. Surgery",

        required: true,
           colSpan: {
            base: 6,
            sm: 6,
            md: 3,
            lg:1
        },
    },

];


